import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';

import BasePanel from './BasePanel';

const CardSkeletonScreen = () => (
    <BasePanel>
        <ContentLoader height={12} width={200} className="margin-bottom-10" />
        <ContentLoader height={15} width={'100%'} />
    </BasePanel>
);

export default CardSkeletonScreen;
